@if (isLoading()) {
    <div *appCardContent>
        <div class="mb-spacing">
            <div class="indent">
                <mat-spinner mode="indeterminate" diameter="30" class="mx-a my-15"></mat-spinner>
            </div>
        </div>
    </div>
} @else {
    @if (!!form) {
        <form [formGroup]="form">

            <div class="field-row">
                <div class="field-row-title">
                    Prefix <span class="text-muted">(e.g. {{form.controls['prefix'].value}}-12345678)</span>
                </div>
                <div class="field-row-element">
                    <mat-form-field appearance="outline" color="accent" class="form-input"
                                    subscriptSizing="dynamic">
                        <input matInput
                               autocomplete="off"
                               type="text"
                               formControlName="prefix"/>
                        @if (form.controls['prefix'].hasError('required')) {
                            <mat-error> Prefix is required.</mat-error>
                        }
                    </mat-form-field>
                </div>

            </div>

            <div class="field-row">
                <div class="field-row-title">
                    Use shift ID as work task ID
                    <div class="text-muted ml-25 whitespace-no-wrap">PlowOps shift ID will be used as work task number in Cartegraph</div>
                </div>
                <div class="field-row-element">
                    <app-row-with-toggle formControlName="useShiftId"></app-row-with-toggle>
                </div>
            </div>

        </form>

    }
}
